import { render, staticRenderFns } from "./SubFolderDocumentSalaryReceipt.vue?vue&type=template&id=97ca426c&scoped=true&"
import script from "./SubFolderDocumentSalaryReceipt.vue?vue&type=script&lang=js&"
export * from "./SubFolderDocumentSalaryReceipt.vue?vue&type=script&lang=js&"
import style0 from "./SubFolderDocumentSalaryReceipt.vue?vue&type=style&index=0&id=97ca426c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ca426c",
  null
  
)

export default component.exports